import styled from 'styled-components'

export const Wrap = styled('div')`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 100px;
`
